import angular from 'angular';
import {SftpExportsListController} from './sftp-exports-list.controller.js';
import {SftpExportEditionController} from './sftp-export-edition.controller.js';
import {SftpExportsService} from './sftp-exports.service.js';

angular
  .module('parameters.sftp-exports', [])
  .controller('SftpExportsListController', SftpExportsListController)
  .controller('SftpExportEditionController', SftpExportEditionController)
  .factory('SftpExportsFactory', SftpExportsService.SftpExportsFactory)
